/**
* 流量分析
*/
<template>
  <div>

    <div class="title">
      流量详情
    </div>
    <div class="content">

      <div class="item">
        <div class="title"></div>
        <div class="checkBoxWrapper">
        </div>
      </div>

      <div class="item">
        <div class="title">时间区间：</div>
        <el-radio-group v-model="radio" @change="selectRadio">
          <el-radio :label="3">最近一小时</el-radio>
          <el-radio :label="6">最近一天</el-radio>
          <el-radio :label="9">最近一周</el-radio>
          <el-radio :label="10">自定义</el-radio>
        </el-radio-group>

        <div v-show="this.radio==10" class="block">
          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="dateChange"
          >
          </el-date-picker>
        </div>

      </div>

      <div class="item">
        <div class="title">横坐标精度：</div>
        <el-radio-group v-model="radio2" @change="selectRadio2">
          <el-radio :label="3" :disabled="this.radio==10 ||this.radio==9">按分钟显示</el-radio>
          <el-radio :label="6" :disabled="this.radio==3">按小时显示</el-radio>
          <el-radio :label="9" :disabled="this.radio==3||this.radio==6">按天显示</el-radio>
        </el-radio-group>
      </div>

      <div class="item">
        <div class="title">选择应用：</div>
        <el-select v-model="value" placeholder="请选择" @change="selectApplication">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.applicationName"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div id="myChart"></div>

    </div>

  </div>
</template>

<script>


import {getAppList, getApiStatistics} from "../../api/appMG";

export default {
  data() {
    let vue = this;
    return {

      userId: this.$store.getters.getUserInfo.userId,

      startTime: "",
      endTime: "",

      value2: "",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date(new Date().toLocaleDateString());
            const start = new Date(new Date().toLocaleDateString());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
            vue.getEcharts();
          }
        },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);

              vue.getEcharts();
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);

              vue.getEcharts();

            }
          }],
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let three = 90 * 24 * 3600 * 1000;
          let threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },


      },

      options: [],
      value: '',
      radio: 3,
      radio2: 3,
      myChart: {},

      startDate: "",
      endDate: "",
      dateType: 1,

      echartsOptions: {
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '调用量',
          type: 'line',
          smooth: true,
          data: []
        }],
        color: ["#00A774"]

      }
    }
  },
  // 注册组件

  /**
   * 创建完毕
   */
  created() {
    this.getdata("")
  },
  mounted() {
    this.drawLine();
  },

  methods: {

    dateChange() {
      this.getEcharts()
    },

    getEcharts() {

      if (this.radio == 3) {
        this.endTime = new Date().getTime();
        this.startTime = new Date();
        this.startTime = this.startTime - 3600 * 1000 * 1;
      }
      if (this.radio == 6) {
        this.endTime = new Date().getTime();
        this.startTime = new Date();
        this.startTime = this.startTime - 3600 * 1000 * 24;
      }
      if (this.radio == 9) {

        this.endTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.startTime - 3600 * 1000 * 24 * 7;
      }
      if (this.radio == 10) {
        this.startTime = new Date(this.value2[0]).getTime()
        this.endTime = new Date(this.value2[1]).getTime()
      }
      if (this.radio2 == 3) {
        this.dateType = 1;
      }
      if (this.radio2 == 6) {
        this.dateType = 2;
      }
      if (this.radio2 == 9) {
        this.dateType = 3
      }

      if (this.value) {
        getApiStatistics({
          "startTime": this.startTime,
          "endTime": this.endTime-1,
          "dateType": this.dateType,
          "applicationId": this.value,
          "userId": this.userId
        }).then(response => {
          console.log(response)

          if (response.status == 200) {

            if (response.data.x.length == 0) {
              this.$message.info("该时间段内无数据");
            }
            this.echartsOptions.xAxis.data = response.data.x
            this.echartsOptions.series[0].data = response.data.y
            this.drawLine();


          } else {
            this.$message.warning(response.message);
          }

        }).catch(error => {
          console.log(e);
          this.$message.error("网络异常，请稍后重试")
        })
      }


    },


    selectApplication() {
      this.getEcharts()
    },

    getdata(applicationName) {
      this.loading = true
      getAppList(
        {
          "userId": this.$store.getters.getUserInfo.userId,
          "applicationName": applicationName
        }
      ).then(response => {
        if (response.status != 200) {
          this.$message.warning(response.message);
        } else {
          this.options = response.data;
        }
      }).then(e => {
        console.log(e)
      })
      this.loading = false
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      this.myChart.setOption(this.echartsOptions);
    },

    selectRadio() {

      if (this.radio == 3) {
        this.radio2 = 3;
      }
      if (this.radio == 6) {
        this.radio2 = 6;
      }
      if (this.radio == 9) {
        this.radio2 = 9;
      }
      if (this.radio == 10) {
        this.radio2 = 9
      }
      if (this.radio != 10) {
        this.getEcharts()
      }
    },
    selectRadio2() {
      this.getEcharts()
    }

  }

}
</script>

<style scoped>

.block {
  margin-left: 3vw;
  height: 2.5vw;
}

.title {
  font-size: 1.12vw;
  margin-left: 2vw;
}

.content {

  height: 65vw;
  margin: 1.5vw 1vw;
  background-color: #ffffff;

  box-shadow: 0.1vw 0.1vw 0.1vw #ffffff;
}

#myChart {
  width: 100%;
  height: 50vw;
}

.item {
  display: flex;
  align-items: center;
  margin: 2.24vw 1vw;
}

.item .title {
  margin-right: 3vw;
  width: 9vw;
}


</style>






// WEBPACK FOOTER //
// src/views/manage/WebTraffic.vue